// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2yb4G","productName":"Table_productName__OaoQb"};